import { useEffect, useRef } from "react";

// Calls `callback` every `intervalMs` while the browser tab is visible; pauses when it is hidden and calls once
// right away when it becomes visible again. The first load stays the caller's (this only refreshes).
// `hiddenIntervalMs`: keep calling while hidden too, at that pace (for something the person must hear about even in
// another tab, like a new assistance request); browsers may still slow it down in a long-hidden tab.
export default function useVisiblePolling(callback, intervalMs, enabled = true, hiddenIntervalMs = null) {
  const saved = useRef(callback);
  useEffect(() => {
    saved.current = callback;
  });

  useEffect(() => {
    if (!enabled) return undefined;
    let timer = null;
    const start = (ms = intervalMs) => {
      if (timer === null) timer = setInterval(() => saved.current(), ms);
    };
    const stop = () => {
      clearInterval(timer);
      timer = null;
    };
    const onVisibility = () => {
      if (document.visibilityState === "visible") {
        stop();
        saved.current();
        start();
      } else {
        stop();
        if (hiddenIntervalMs) start(hiddenIntervalMs);
      }
    };
    if (document.visibilityState === "visible") start();
    else if (hiddenIntervalMs) start(hiddenIntervalMs);
    document.addEventListener("visibilitychange", onVisibility);
    return () => {
      stop();
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [intervalMs, enabled, hiddenIntervalMs]);
}
